export default __webpack_public_path__ + "static/media/Visa_2014_logo_detail.svg.34d16bea.png";